export const basic = [
  { key: 'year', label: 'Year' },
  { key: 'team_id', label: 'School', class: 'team-name-col !text-left' },
  { key: 'games_started', label: 'GS' },
  { key: 'games_appeared', label: 'App' },
  { key: 'games', label: 'G' },
  { key: 'earned_run_average', label: 'ERA' },
  { key: 'innings_pitched', label: 'IP' },
  { key: 'complete_games', label: 'CG' },
  { key: 'hits_allowed', label: 'H' },
  { key: 'runs_allowed', label: 'R' },
  { key: 'earned_runs', label: 'ER' },
  { key: 'walks_issued', label: 'BB' },
  { key: 'strikeouts', label: 'SO' },
  { key: 'shutouts', label: 'SHO' },
  { key: 'batters_faced', label: 'BF' },
  { key: 'opponent_at_bats', label: 'P-OAB' },
  { key: 'doubles_allowed', label: '2B-A' },
  { key: 'triples_allowed', label: '3B-A' },
  { key: 'balk', label: 'Bk' },
  { key: 'homeruns_allowed', label: 'HR-A' },
  { key: 'wild_pitch', label: 'WP' },
  { key: 'hit_batter', label: 'HB' },
  { key: 'intentional_walk_allowed', label: 'IBB' },
  { key: 'sac_hit_allowed', label: 'SHA' },
  { key: 'sac_fly_allowed', label: 'SFA' },
  { key: 'wins', label: 'W' },
  { key: 'losses', label: 'L' },
  { key: 'saves', label: 'SV' },
  { key: 'pickoffs', label: 'pickoffs' },
];

export const advanced = [
  { key: 'year', label: 'Year' },
  { key: 'team_id', label: 'School', class: 'team-name-col !text-left' },
  { key: 'inherited_runner', label: 'Inh Run' },
  { key: 'inherited_runner_scored', label: 'Inh Run Score' },
  { key: 'pitches', label: 'Pitches' },
  { key: 'ground_out', label: 'GO' },
  { key: 'fly_out', label: 'FO' },
  { key: 'strikeout_looking', label: 'KL' },
  { key: 'batting_average_against', label: 'BA-P' },
  { key: 'on_base_percentage_against', label: 'OBP-P' },
  { key: 'slugging_percentage_against', label: 'SLG-P' },
  { key: 'on_base_plus_slugging_against', label: 'OPS' },
  { key: 'batting_average_on_balls_in_play', label: 'BABIP' },
  { key: 'walk_percentage', label: 'BB%' },
  { key: 'strikeout_percentage', label: 'K%' },
  { key: 'strikeout_minus_walk_percentage', label: 'K-BB%' },
  { key: 'strikeout_to_walk_ratio', label: 'K:BB' },
  { key: 'walks_plus_hits_per_inning_pitched', label: 'WHIP' },
  { key: 'fielding_independent_pitching', label: 'FIP' },
  { key: 'expected_fielding_independent_pitching', label: 'xFIP' },
  { key: 'skill_interactive_earned_run_average', label: 'SIERA' },
  { key: 'left_on_base_percentage', label: 'LOB%' },
  { key: 'ground_out_per_air_out', label: 'GO/AO' },
  { key: 'home_run_to_fly_ball_percentage', label: 'HR/FB%' },
  { key: 'strikeout_looking_percentage', label: 'KL%' },
  { key: 'strikeout_swinging_percentage', label: 'KS%' },
  { key: 'pitches_per_inning', label: 'PC/IP' },
];
export const basicTeam = [
  { key: 'year', label: 'Year' },
  { key: 'games', label: 'G' },
  { key: 'earned_run_average', label: 'ERA' },
  { key: 'innings_pitched', label: 'IP' },
  { key: 'complete_games', label: 'CG' },
  { key: 'hits_allowed', label: 'H' },
  { key: 'runs_allowed', label: 'R' },
  { key: 'earned_runs', label: 'ER' },
  { key: 'walks_issued', label: 'BB' },
  { key: 'strikeouts', label: 'SO' },
  { key: 'shutouts', label: 'SHO' },
  { key: 'batters_faced', label: 'BF' },
  { key: 'opponent_at_bats', label: 'P-OAB' },
  { key: 'doubles_allowed', label: '2B-A' },
  { key: 'triples_allowed', label: '3B-A' },
  { key: 'balk', label: 'Bk' },
  { key: 'homeruns_allowed', label: 'HR-A' },
  { key: 'wild_pitch', label: 'WP' },
  { key: 'hit_batter', label: 'HB' },
  { key: 'intentional_walk_allowed', label: 'IBB' },
  { key: 'sac_hit_allowed', label: 'SHA' },
  { key: 'sac_fly_allowed', label: 'SFA' },
  { key: 'wins', label: 'W' },
  { key: 'losses', label: 'L' },
  { key: 'saves', label: 'SV' },
  { key: 'pickoffs', label: 'Pickoffs' },
];

export const advancedTeam = [
  { key: 'year', label: 'Year' },
  { key: 'inherited_runner', label: 'Inh Run' },
  { key: 'inherited_runner_scored', label: 'Inh Run Score' },
  { key: 'pitches', label: 'Pitches' },
  { key: 'ground_out', label: 'GO' },
  { key: 'fly_out', label: 'FO' },
  { key: 'Strikeout_looking', label: 'KL' },
  { key: 'batting_average_against', label: 'BA-P' },
  { key: 'on_base_percentage_against', label: 'OBP-P' },
  { key: 'slugging_percentage_against', label: 'SLG-P' },
  { key: 'on_base_plus_slugging_against', label: 'OPS' },
  { key: 'batting_average_on_balls_in_play', label: 'BABIP' },
  { key: 'walk_percentage', label: 'BB%' },
  { key: 'strikeout_percentage', label: 'K%' },
  { key: 'strikeout_minus_walk_percentage', label: 'K-BB%' },
  { key: 'strikeout_to_walk_ratio', label: 'K:BB' },
  { key: 'walks_plus_hits_per_inning_pitched', label: 'WHIP' },
  { key: 'fielding_independent_pitching', label: 'FIP' },
  { key: 'expected_fielding_independent_pitching', label: 'xFIP' },
  { key: 'skill_interactive_earned_run_average', label: 'SIERA' },
  { key: 'left_on_base_percentage', label: 'LOB%' },
  { key: 'ground_out_per_air_out', label: 'GO/AO' },
  { key: 'home_run_to_fly_ball_percentage', label: 'HR/FB%' },
  { key: 'strikeout_looking_percentage', label: 'KL%' },
  { key: 'strikeout_swinging_percentage', label: 'KS%' },
  { key: 'pitches_per_inning', label: 'PC/IP' },
];
